export default __webpack_public_path__ + "static/media/bg.265d44ae.jpg";